<template>
  <div class="contentArea">
    <base-dialog :show="successModal" small>
      <div class="success my-10">
        <img src="../assets/success.svg" alt="" />
        <h2 class="mt-10 text-white">{{ successText }}</h2>
      </div>
    </base-dialog>
    <base-dialog :show="deleteModal" small>
      <div class="my-5 mx-5">
        <h4 class="text-white">ยืนยันการลบประเภทแอดมินนี้</h4>
        <div class="grid grid-cols-12 gap-4 mt-20">
          <vs-button
            class="col-end-9 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="deleteModal = false"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-13 col-span-4"
            color="#15c1c3"
            @click="confirmDeleteRole"
            >ยืนยัน</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <base-dialog :show="addRoleDialog" small>
      <form @submit.prevent="addNewRole">
        <h2 class="text-center mt-6 mb-8">เพิ่มประเภทแอดมิน</h2>
        <div class="grid grid-cols-12 gap-x-10 gap-y-3 px-20 items-center">
          <p class="col-span-3 text-right">ชื่อ</p>
          <input
            type="text"
            class="col-span-8"
            placeholder="ชื่อประเภทแอดมิน"
            required
            v-model="roleName"
          />
        </div>
        <div class="grid grid-cols-10 gap-x-3 mt-8 mb-6">
          <vs-button
            class="col-span-3 col-start-3"
            color="#ffffff"
            text-color="#8d9498"
            @click="toggleAddRole"
          >
            ยกเลิก
          </vs-button>
          <vs-button class="col-span-3" button="submit" color="#15c1c3">
            บันทึก
          </vs-button>
        </div>
      </form>
    </base-dialog>
    <div class="grid grid-cols-12">
      <div class="col-span-9">
        <div class="card">
          <vs-checkbox
            color="#57c293"
            :value="dashboard"
            @change="setDashboard($event)"
          >
            <h5>Dashboard</h5>
          </vs-checkbox>
          <div class="grid grid-cols-5 gap-y-3 mt-5 ml-10">
            <vs-checkbox color="#57c293" v-model="dView">
              <p>View</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="dEdit">
              <p>Edit</p>
            </vs-checkbox>
          </div>
          <vs-checkbox
            color="#57c293"
            class="mt-8"
            :value="task"
            @change="setTask($event)"
          >
            <h5>Task</h5>
          </vs-checkbox>
          <div class="grid grid-cols-5 mt-5 ml-10">
            <vs-checkbox color="#57c293" v-model="tView">
              <p>View Task</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="tCreate">
              <p>Create Task</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="tEdit">
              <p>Edit Task</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="tDelete">
              <p>Delete Task</p>
            </vs-checkbox>
          </div>
          <vs-checkbox
            color="#57c293"
            :value="invoice"
            @change="setInvoice($event)"
            class="mt-8"
          >
            <h5>Invoice Management</h5>
          </vs-checkbox>
          <div class="grid grid-cols-5 mt-5 ml-10">
            <vs-checkbox color="#57c293" v-model="iView">
              <p>View Invoice</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="iCreate">
              <p>Create Invoice</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="iEdit">
              <p>Edit Invoice</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="iDelete">
              <p>Delete Invoice</p>
            </vs-checkbox>
          </div>
          <vs-checkbox
            color="#57c293"
            :value="receipt"
            @change="setReceipt($event)"
            class="mt-8"
          >
            <h5>Receipt Management</h5>
          </vs-checkbox>
          <div class="grid grid-cols-5 mt-5 ml-10">
            <vs-checkbox color="#57c293" v-model="reView">
              <p>View Receipt</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="reCreate">
              <p>Create Receipt</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="reEdit">
              <p>Edit Receipt</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="reDelete">
              <p>Delete Receipt</p>
            </vs-checkbox>
          </div>
          <vs-checkbox
            color="#57c293"
            :value="user"
            @change="setUser($event)"
            class="mt-8"
          >
            <h5>User Management</h5>
          </vs-checkbox>
          <div class="grid grid-cols-5 gap-y-5 mt-5 ml-10">
            <vs-checkbox color="#57c293" v-model="uView">
              <p>View User</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="uAdd">
              <p>Add User</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="uEdit">
              <p>Edit User</p>
            </vs-checkbox>
            <vs-checkbox class="col-span-2" color="#57c293" v-model="uRights">
              <p>Rights Management</p>
            </vs-checkbox>
            <!-- <vs-checkbox color="#57c293" v-model="uFile">
              <p>File Management</p>
            </vs-checkbox> -->
            <vs-checkbox color="#57c293" v-model="uDelete">
              <p>Delete User</p>
            </vs-checkbox>
          </div>
          <vs-checkbox
            color="#57c293"
            :value="admin"
            @change="setAdmin($event)"
            class="mt-8"
          >
            <h5>Admin Management</h5>
          </vs-checkbox>
          <div class="grid grid-cols-5 mt-5 ml-10">
            <vs-checkbox color="#57c293" v-model="aView">
              <p>View Admin</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="aCreate">
              <p>Create Admin</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="aDelete">
              <p>Delete Admin</p>
            </vs-checkbox>
          </div>
          <vs-checkbox
            color="#57c293"
            :value="roles"
            @change="setRole($event)"
            class="mt-8"
          >
            <h5>Roles Management</h5>
          </vs-checkbox>
          <div class="grid grid-cols-5 mt-5 ml-10">
            <vs-checkbox color="#57c293" v-model="rAdd">
              <p>Add New Roles</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="rEdit">
              <p>Edit Roles</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="rDelete">
              <p>Delete Roles</p>
            </vs-checkbox>
          </div>
          <vs-checkbox
            color="#57c293"
            :value="setting"
            @change="setSetting($event)"
            class="mt-8"
          >
            <h5>Setting</h5>
          </vs-checkbox>
          <div class="grid grid-cols-5 gap-y-5 mt-5 ml-10">
            <vs-checkbox color="#57c293" v-model="sAddOwn">
              <p>Add Owner</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="sEditOwn">
              <p>Edit Owner</p>
            </vs-checkbox>
            <vs-checkbox
              class="col-span-3"
              color="#57c293"
              v-model="sDeleteOwn"
            >
              <p>Delete Owner</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="sAddBank">
              <p>Add Bank Account</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" v-model="sEditBank">
              <p>Edit Bank Account</p>
            </vs-checkbox>
            <vs-checkbox color="#57c293" class="col-span-3" v-model="sDeleteBank">
              <p>Delete Bank Account</p>
            </vs-checkbox>
          </div>
        </div>
        <div v-if="permission.role_edit" class="grid grid-cols-12 gap-4">
          <vs-button
            class="col-end-11 col-span-2 mt-5 mb-8"
            color="#ffffff"
            text-color="#8d9498"
            @click="goBackPage"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-13 col-span-2 mt-5 mb-8"
            color="#15c1c3"
            @click="editPermission"
            >บันทึก</vs-button
          >
        </div>
      </div>
      <div class="col-span-3 role-container">
        <h1 class="mt-8 ml-8">Roles</h1>
        <div
          v-if="permission.role_add"
          class="add-role flex justify-between"
          @click="toggleAddRole"
        >
          <p style="color: #434f5b">Add New Role</p>
          <font-awesome-icon icon="plus" />
        </div>
        <transition-group name="left-in">
          <div
            v-for="role in roleList"
            :key="role.role_id"
            class="role-item"
            :class="{ selected: role.role_id === selectedRole.role_id }"
            @click="changeSelectedRole(role)"
          >
            <p>{{ role.role_name }}</p>
            <div
              v-if="role.role_name !== 'Super Admin' && permission.role_delete"
              class="bin-icon"
              @click="showDeleteRole"
            >
              <font-awesome-icon
                icon="trash-alt"
                :style="{ color: '#ff4a3d' }"
              />
            </div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "../util/backend.js";
export default {
  data() {
    return {
      successModal: false,
      successText: "",
      deleteModal: false,
      addRoleDialog: false,
      roleName: "", // ใน dialog
      roleList: [],
      selectedRole: null,
      // Dashboard
      dView: false,
      dEdit: false,
      // Task
      tView: false,
      tCreate: false,
      tEdit: false,
      tDelete: false,
      // Invoice
      iView: false,
      iCreate: false,
      iEdit: false,
      iDelete: false,
      // Receipt
      reView: false,
      reCreate: false,
      reEdit: false,
      reDelete: false,
      // User
      uView: false,
      uAdd: false,
      uEdit: false,
      uRights: false,
      uFile: false,
      uDelete: false,
      // Admin
      aView: false,
      aCreate: false,
      aDelete: false,
      // Role
      rAdd: false,
      rEdit: false,
      rDelete: false,
      // Setting
      sAddOwn: false,
      sEditOwn: false,
      sDeleteOwn: false,
      sAddBank: false,
      sEditBank: false,
      sDeleteBank: false,
    };
  },
  computed: {
    dashboard() {
      return this.dView && this.dEdit;
    },
    task() {
      return this.tView && this.tCreate && this.tEdit && this.tDelete;
    },
    invoice() {
      return this.iView && this.iCreate && this.iEdit && this.iDelete;
    },
    receipt() {
      return this.reView && this.reCreate && this.reEdit && this.reDelete;
    },
    user() {
      return (
        this.uView &&
        this.uAdd &&
        this.uEdit &&
        this.uRights &&
        this.uFile &&
        this.uDelete
      );
    },
    admin() {
      return this.aView && this.aCreate && this.aEdit && this.aDelete;
    },
    roles() {
      return this.rAdd && this.rEdit && this.rDelete;
    },
    setting() {
      return (
        this.sAddOwn &&
        this.sEditOwn &&
        this.sDeleteOwn &&
        this.sAddBank &&
        this.sEditBank &&
        this.sDeleteBank
      );
    },
    permission() {
      return this.$store.getters.getPermission;
    },
  },
  methods: {
    toggleAddRole() {
      this.addRoleDialog = !this.addRoleDialog;
      this.roleName = "";
    },
    setDashboard(event) {
      if (event.target.checked) {
        this.dView = true;
        this.dEdit = true;
      } else {
        this.dView = false;
        this.dEdit = false;
      }
    },
    setTask(event) {
      if (event.target.checked) {
        this.tView = true;
        this.tCreate = true;
        this.tEdit = true;
        this.tDelete = true;
      } else {
        this.tView = false;
        this.tCreate = false;
        this.tEdit = false;
        this.tDelete = false;
      }
    },
    setInvoice(event) {
      if (event.target.checked) {
        this.iView = true;
        this.iCreate = true;
        this.iEdit = true;
        this.iDelete = true;
      } else {
        this.iView = false;
        this.iCreate = false;
        this.iEdit = false;
        this.iDelete = false;
      }
    },
    setReceipt(event) {
      if (event.target.checked) {
        this.reView = true;
        this.reCreate = true;
        this.reEdit = true;
        this.reDelete = true;
      } else {
        this.reView = false;
        this.reCreate = false;
        this.reEdit = false;
        this.reDelete = false;
      }
    },
    setUser(event) {
      if (event.target.checked) {
        this.uView = true;
        this.uAdd = true;
        this.uEdit = true;
        this.uRights = true;
        this.uFile = true;
        this.uDelete = true;
      } else {
        this.uView = false;
        this.uAdd = false;
        this.uEdit = false;
        this.uRights = false;
        this.uFile = false;
        this.uDelete = false;
      }
    },
    setAdmin(event) {
      if (event.target.checked) {
        this.aView = true;
        this.aCreate = true;
        this.aEdit = true;
        this.aDelete = true;
      } else {
        this.aView = false;
        this.aCreate = false;
        this.aEdit = false;
        this.aDelete = false;
      }
    },
    setRole(event) {
      if (event.target.checked) {
        this.rAdd = true;
        this.rEdit = true;
        this.rDelete = true;
      } else {
        this.rAdd = false;
        this.rEdit = false;
        this.rDelete = false;
      }
    },
    setSetting(event) {
      if (event.target.checked) {
        this.sAddOwn = true;
        this.sEditOwn = true;
        this.sDeleteOwn = true;
        this.sAddBank = true;
        this.sEditBank = true;
        this.sDeleteBank = true;
        this.sEdit = true;
      } else {
        this.sAddOwn = false;
        this.sEditOwn = false;
        this.sDeleteOwn = false;
        this.sAddBank = false;
        this.sEditBank = false;
        this.sDeleteBank = false;
        this.sEdit = false;
      }
    },
    async addNewRole() {
      try {
        const res = await axios.post(
          `${baseUrl}/role/create`,
          {
            role_name: this.roleName,
            dashboard_view: true,
            dashboard_edit: true,
            task_view: true,
            task_create: true,
            task_edit: true,
            task_delete: true,
            invoice_view: true,
            invoice_create: true,
            invoice_edit: true,
            invoice_delete: true,
            receipt_view: true,
            receipt_create: true,
            receipt_edit: true,
            receipt_delete: true,
            user_view: true,
            user_add: true,
            user_edit: true,
            user_rights: true,
            user_file: true,
            user_delete: true,
            admin_view: true,
            admin_create: true,
            admin_edit: true,
            admin_delete: true,
            role_add: true,
            role_edit: true,
            role_delete: true,
            setting_add_owner: true,
            setting_edit_owner: true,
            setting_delete_owner: true,
            setting_add_bank: true,
            setting_edit_bank: true,
            setting_delete_bank: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        console.log(res);
        if (res.data.status === "success") {
          this.toggleAddRole();
          this.successText = "เพิ่มสำเร็จ";
          this.successModal = true;
          setTimeout(() => {
            this.successModal = false;
            this.loadRoleList();
          }, 1000);
        } else {
          const error = new Error("สร้างประเภทแอดมินไม่สำเร็จ");
          throw error;
        }
      } catch (err) {
        alert(err);
      }
    },
    async editPermission() {
      try {
        const res = await axios.post(
          `${baseUrl}/role/edit?role_id=${this.selectedRole.role_id}`,
          {
            role_name: this.selectedRole.role_name,
            dashboard_view: this.dView,
            dashboard_edit: this.dEdit,
            task_view: this.tView,
            task_create: this.tCreate,
            task_edit: this.tEdit,
            task_delete: this.tDelete,
            invoice_view: this.iView,
            invoice_create: this.iCreate,
            invoice_edit: this.iEdit,
            invoice_delete: this.iDelete,
            receipt_view: this.reView,
            receipt_create: this.reCreate,
            receipt_edit: this.reEdit,
            receipt_delete: this.reDelete,
            user_view: this.uView,
            user_add: this.uAdd,
            user_edit: this.uEdit,
            user_rights: this.uRights,
            user_file: this.uFile,
            user_delete: this.uDelete,
            admin_view: this.aView,
            admin_create: this.aCreate,
            admin_edit: this.aEdit,
            admin_delete: this.aDelete,
            role_add: this.rAdd,
            role_edit: this.rEdit,
            role_delete: this.rDelete,
            setting_add_owner: this.sAddOwn,
            setting_edit_owner: this.sEditOwn,
            setting_delete_owner: this.sDeleteOwn,
            setting_add_bank: this.sAddBank,
            setting_edit_bank: this.sEditBank,
            setting_delete_bank: this.sDeleteBank,
          },
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        console.log(res);
        if (res.data.status === "success") {
          this.successText = "แก้ไขสำเร็จ";
          this.successModal = true;
          setTimeout(() => {
            this.successModal = false;
            this.loadRoleList();
          }, 1000);
        } else {
          const error = new Error("แก้ไขสิทธิไม่สำเร็จ");
        }
      } catch (err) {
        alert(err);
      }
    },
    changeSelectedRole(role) {
      this.selectedRole = role;
      this.setPermission();
    },
    async showDeleteRole() {
      this.deleteModal = true;
    },
    async confirmDeleteRole() {
      const res = await axios.post(
        `${baseUrl}/role/delete?role_id=${this.selectedRole.role_id}`,
        {},
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(res);
      this.deleteModal = false;
      this.loadRoleList();
    },
    async loadRoleList() {
      const res = await axios.get(`${baseUrl}/role/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      const roles = res.data.data;
      console.log(roles);
      this.roleList = roles;
      if (!this.selectedRole) {
        this.selectedRole = this.roleList[0];
        this.setPermission();
      }
    },
    setPermission() {
      this.dView = this.selectedRole.dashboard_view;
      this.dEdit = this.selectedRole.dashboard_edit;
      this.tView = this.selectedRole.task_view;
      this.tCreate = this.selectedRole.task_create;
      this.tEdit = this.selectedRole.task_edit;
      this.tDelete = this.selectedRole.task_delete;
      this.iView = this.selectedRole.invoice_view;
      this.iCreate = this.selectedRole.invoice_create;
      this.iEdit = this.selectedRole.invoice_edit;
      this.iDelete = this.selectedRole.invoice_delete;
      this.reView = this.selectedRole.receipt_view;
      this.reCreate = this.selectedRole.receipt_create;
      this.reEdit = this.selectedRole.receipt_edit;
      this.reDelete = this.selectedRole.receipt_delete;
      this.uView = this.selectedRole.user_view;
      this.uAdd = this.selectedRole.user_add;
      this.uEdit = this.selectedRole.user_edit;
      this.uRights = this.selectedRole.user_rights;
      this.uFile = this.selectedRole.user_file;
      this.uDelete = this.selectedRole.user_delete;
      this.uManage = this.selectedRole.user_manage;
      this.aView = this.selectedRole.admin_view;
      this.aCreate = this.selectedRole.admin_create;
      this.aEdit = this.selectedRole.admin_edit;
      this.aDelete = this.selectedRole.admin_delete;
      this.rAdd = this.selectedRole.role_add;
      this.rEdit = this.selectedRole.role_edit;
      this.rDelete = this.selectedRole.role_delete;
      this.sAddOwn = this.selectedRole.setting_add_owner;
      this.sEditOwn = this.selectedRole.setting_edit_owner;
      this.sDeleteOwn = this.selectedRole.setting_delete_owner;
      this.sAddBank = this.selectedRole.setting_add_bank;
      this.sEditBank = this.selectedRole.setting_edit_bank;
      this.sDeleteBank = this.selectedRole.setting_delete_bank;
    },
    goBackPage() {
      this.$router.go();
    },
  },
  created() {
    this.loadRoleList();
  },
};
</script>

<style scoped>
h1,
h2,
h5,
p,
p {
  color: white;
}

p {
  font-weight: normal;
}

.card {
  background-color: #4e5363;
  border-radius: 5px;
  padding: 35px;
}

.box {
  padding: 27px;
  border: 1px solid #3a3f51;
  border-radius: 5px;
}

.role-container {
  margin: -35px -24px 0 10%;
  background-color: #4e5363;
  overflow-y: auto;
}

.role-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px 30px;
  border-bottom: 1px solid #8d9498;
}

.add-role {
  width: 100%;
  padding: 20px 30px;
  border-bottom: 1px solid #8d9498;
  background-color: #dddddd;
}
.add-role:hover {
  cursor: pointer;
  background-color: #b0b0b0;
}

.role-item:hover {
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.096);
}

.selected {
  background-color: #15c1c3;
}

.selected:hover {
  background-color: #15c1c3;
}

input[type="text"] {
  border-radius: 2px;
  background: #434f5b;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

input[type="text"] {
  height: 34px;
  min-width: 0;
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bin-icon {
  text-align: center;
  width: 22px;
  height: 22px;
  border-radius: 7px;
  border: solid 1px #ff4a3d;
  cursor: pointer;
}

.left-in-enter,
.left-in-leave-to {
  opacity: 0;
  transform: translateX(50%);
}

.left-in-enter-active {
  transition: all 0.3s ease-out;
}

.left-in-leave-active {
  transition: all 0.3s ease-in;
}

.left-in-enter-to,
.left-in-leave {
  opacity: 1;
  transform: translateX(0%);
}
</style>
